import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Wed Jan 02 2019
 * @author Tomáš Leity
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { observable, runInAction } from 'mobx';
import { WindowFileLayer } from '../../transportLayers/window/WindowFileLayer';
import { FileDownload } from '../../../shared/document/FileDownload';
import { BaseStore } from '../BaseStore';
import { StoreName } from '../StoreName';
/**
 * Persistent store for WindowFile
 */

export var WindowFileStore =
/*#__PURE__*/
function (_BaseStore) {
  _inherits(WindowFileStore, _BaseStore);

  function WindowFileStore() {
    var _this;

    _classCallCheck(this, WindowFileStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowFileStore).apply(this, arguments));
    /** Store name */

    _this.name = StoreName.WindowFile;
    /** Layer contains methods for fetching data */

    _this.windowFileLayer = new WindowFileLayer();
    /** List of WindowFiles */

    _this.list = new Map();
    /**
     * Gets all WindowFile documents
     * @param windowId
     * @returns a Promise with all WindowFiles
     */

    _this.getAll = function (windowId) {
      return _this.windowFileLayer.findAll(windowId).then(function (windowFiles) {
        _this.list.clear();

        runInAction(function () {
          windowFiles.forEach(function (file) {
            _this.list = _this.list.set(file.id, file);
          });
        });
        return windowFiles;
      });
    };
    /**
     * Upload WindowFile document
     * @param windowId
     * @param values
     * @returns a Promise with uploaded WindowFile
     */


    _this.upload = function (windowId, values) {
      var data = new FormData();
      data.append('windowId', windowId);
      data.append('dataFile', values.dataFile.data);

      if (values.note) {
        data.append('note', values.note);
      }

      return _this.windowFileLayer.upload(data).then(function (windowFile) {
        runInAction(function () {
          _this.list = _this.list.set(windowFile.id, windowFile);
        });
        return windowFile;
      });
    };
    /**
     * Download WindowFile document
     * @param fileId
     * @returns a Promise
     */


    _this.download = function (fileId) {
      return _this.windowFileLayer.download(fileId).then(function (response) {
        var download = new FileDownload(response.data, response.headers);
        return download.process();
      });
    };
    /**
     * Delete WindowFile document
     * @param fileId
     * @returns a Promise with response
     */


    _this.delete = function (fileId) {
      return _this.windowFileLayer.delete(fileId).then(function (response) {
        runInAction(function () {
          _this.list.delete(fileId);
        });
        return response;
      });
    };

    return _this;
  }

  return WindowFileStore;
}(BaseStore);

__decorate([observable, __metadata("design:type", Map)], WindowFileStore.prototype, "list", void 0);